import { render, staticRenderFns } from "./physioRegister.vue?vue&type=template&id=4ec8ff17&scoped=true"
import script from "./physioRegister.vue?vue&type=script&lang=js"
export * from "./physioRegister.vue?vue&type=script&lang=js"
import style0 from "./physioRegister.vue?vue&type=style&index=0&id=4ec8ff17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8ff17",
  null
  
)

export default component.exports